import collection from './collection'
export default collection
